import CircularProgress from "@mui/material/CircularProgress";
import { theme as defaultTheme } from "@mindlercare/ui-web";
import { useTranslation } from "react-i18next";
import { styled } from "styled-components";

const StyledLoadingView = styled.div`
  height: 100%;
  color: ${(props) => defaultTheme.COLORS.GRAY_BLACK};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  svg circle {
    color: ${(props) => defaultTheme.COLORS.GRAY_BLACK};
  }
`;

export const LoadingView = () => {
  const { t } = useTranslation();
  return (
    <StyledLoadingView data-testid="loadingView">
      <CircularProgress />
      <p>{t("LOADING_CONFIGURATION")}</p>
    </StyledLoadingView>
  );
};
